var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center gap-2",class:{ 'opacity-50 cursor-not-allowed': _vm.disabled },on:{"mouseover":function($event){_vm.upHere = true},"mouseleave":function($event){_vm.upHere = false}}},[_c('div',{staticClass:"rounded-full border-2 mr-1",class:{
      'border-4': _vm.checked || _vm.upHere || _vm.hover,
      'border-accent-300': _vm.checked,
      'bg-accent-50': _vm.checked,
    },staticStyle:{"width":"1em","height":"1em"}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }